import { render, staticRenderFns } from "./OcasList.vue?vue&type=template&id=064d0618&scoped=true&"
import script from "./OcasList.vue?vue&type=script&lang=js&"
export * from "./OcasList.vue?vue&type=script&lang=js&"
import style0 from "./OcasList.vue?vue&type=style&index=0&id=064d0618&lang=scss&scoped=true&"
import style1 from "./OcasList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064d0618",
  null
  
)

export default component.exports